var React = require('react');

function Link (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"link-external","d":"M7.25,8.5h3.125V9.75H7.25v5h5V11.625H13.5V14.75A1.25,1.25,0,0,1,12.25,16h-5A1.25,1.25,0,0,1,6,14.75v-5A1.25,1.25,0,0,1,7.25,8.5Zm6.634-1.25H11V6h5v5H14.75V8.151l-3.335,3.335-.884-.884Z","transform":"translate(-6 -6)","fill":"#aaa","fillRule":"evenodd"}));
}

Link.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 10 10","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = Link;

Link.default = Link;
